module.exports = __webpack_public_path__ + "static/media/forest-crossroads.91523d21.png";